import React, { Fragment } from 'react'
import {
  SpacerVertical,
  Typography,
  IconCalendar,
  IconScissors,
  IconHourglass,
  IconTransfer,
  IconCreditCard,
  SpacerHorizontal,
  Frame,
} from '@klarna/bubble-ui'

import styles from './PaymentMethod.css'

type PaymentMethodsProps = {
  heading: string
  paragraph: string
  paymentMethodIllustration: string
  index: number
  frameBackground: string
};

const Illustrations = {
  IconCalendar: (
    <IconCalendar size={20} />
  ),
  IconScissors: (
    <IconScissors size={20} />
  ),
  IconHourglass: <IconHourglass size={20} />,
  IconTransfer: <IconTransfer size={20} />,
  IconCreditCard: <IconCreditCard size={20} />,
  IconCalendarLarge: (
    <IconCalendar size={48} />
  ),
  IconScissorsLarge: (
    <IconScissors size={48} />
  ),
  IconHourglassLarge: (
    <IconHourglass size={48} />
  ),
  IconTransferLarge: <IconTransfer size={48} />,
}

const PaymentMethods: React.FC<PaymentMethodsProps> = ({
  heading,
  paragraph,
  index,
  frameBackground,
  paymentMethodIllustration,
}) => (
  <div className={`payment-method payment-method-${index + 1}`}>
    <style>{styles}</style>
    <Frame backgroundColorToken={frameBackground} id='payment-method-container'>
      <div className='illustration'>
        {Illustrations[index ? `${paymentMethodIllustration}` : `${paymentMethodIllustration}Large`]}
      </div>
      {index < 3 ? <SpacerHorizontal spaceToken="space.100" /> : null}
      <div style={{ width: '100%' }}>
        <Fragment>
          <SpacerVertical spaceToken="space.0" />
          <Typography textToken="text-style/text/labels/body/bold">{heading}</Typography>
          <SpacerVertical spaceToken="space.0" />
          <Typography textToken="text-style/text/labels/tiny/regular" colorToken="colors/text/subtle">
            {paragraph}
          </Typography>
        </Fragment>
      </div>
    </Frame>
  </div>
)

export default PaymentMethods
